module.exports = __webpack_public_path__ + "corteva.33d93062f0f5b7a1ebf6.svg";


//////////////////
// WEBPACK FOOTER
// F:/PHAZP5152IS01-2/_work/98/s/src/assets/corteva.svg
// module id = wZvJ
// module chunks = 0